import { KeyValue } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class FAQService {
  readonly FAQEntities: KeyValue<string, string>[] = [
    {
      key: 'faq.questionOne',
      value: 'faq.answerOne',
    },
    {
      key: 'faq.questionTwo',
      value: 'faq.answerTwo',
    },
    {
      key: 'faq.questionThree',
      value: 'faq.answerThree',
    },
    {
      key: 'faq.questionFour',
      value: 'faq.answerFour',
    },
    {
      key: 'faq.questionFive',
      value: 'faq.answerFive',
    },
    {
      key: 'faq.questionSix',
      value: 'faq.answerSix',
    },
    {
      key: 'faq.questionSeven',
      value: 'faq.answerSeven',
    },
    {
      key: 'faq.questionEight',
      value: 'faq.answerEight',
    },
    {
      key: 'faq.questionNine',
      value: 'faq.answerNine',
    },
    {
      key: 'faq.questionTen',
      value: 'faq.answerTen',
    },
    {
      key: 'faq.questionEleven',
      value: 'faq.answerEleven',
    },
    {
      key: 'faq.questionTwelve',
      value: 'faq.answerTwelve',
    },
  ];
}
